import axiosConfig from "../configs/axiosConfig";

export const uploadFile = async (formData) => {
  try {
    const response = await axiosConfig({
      method: "POST",
      url: "/public/upload.php",
      data: formData,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};
